import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { RouteAction } from '@core/action/action';
import { HistoricoAcessoComponent } from './pages/historico-acesso-list/historico-acesso.component';
import { SessaoAtivaComponent } from './pages/sessao-ativa-list/sessao-ativa.component';
import { RelatorioEmailComponent } from './pages/relatorio-email-geral-list/relatorio-email-geral.component';
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'historico-acesso',
        component: HistoricoAcessoComponent,
        canActivate: [AuthGuardService],
        data: {
          acao: RouteAction.Visualizar,
          headerPage: {
            titlePage: 'Histórico de Acesso',
            subTitlePage: 'Visualize o histórico de acesso dos usuários',
          },
        },
      },
      {
        path: 'sessao-ativa',
        component: SessaoAtivaComponent,
        canActivate: [AuthGuardService],
        data: {
          acao: RouteAction.Visualizar,
          headerPage: {
            titlePage: 'Sessões Ativas',
            subTitlePage: 'Acompanhe as sessões ativas no sistema',
          },
        },
      },
      {
        path: 'email',
        component: RelatorioEmailComponent,
        canActivate: [AuthGuardService],
        data: {
          acao: RouteAction.Visualizar,
          headerPage: {
            titlePage: 'Relatório de Cadastro por E-mail',
            subTitlePage: 'Encontre registros associados a um e-mail no sistema',
          },
        },
      },
      {
        path: '',
        redirectTo: 'historico-acesso',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RelatoriosRoutingModule {}
